/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Db_Title2Inputs */

const en_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema & query optimization`)
};

const ar_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحسين المخطط والاستعلام`)
};

const bn_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কিমা ও কুয়েরি অপটিমাইজেশন`)
};

const de_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema- und Abfrageoptimierung`)
};

const es_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimización de esquemas y consultas`)
};

const fr_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimisation des schémas et des requêtes`)
};

const pt_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otimização de esquema e consulta`)
};

const zh_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`架构和查询优化`)
};

const tr_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şema ve sorgu optimizasyonu`)
};

const ru_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оптимизация схемы и запросов`)
};

const pl_svc_backend_development_db_title2 = /** @type {(inputs: Svc_Backend_Development_Db_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optymalizacja schematu i zapytań`)
};

/**
* | output |
* | --- |
* | "Schema & query optimization" |
*
* @param {Svc_Backend_Development_Db_Title2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_db_title2 = /** @type {((inputs?: Svc_Backend_Development_Db_Title2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Db_Title2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_db_title2(inputs)
	if (locale === "bn") return bn_svc_backend_development_db_title2(inputs)
	if (locale === "de") return de_svc_backend_development_db_title2(inputs)
	if (locale === "es") return es_svc_backend_development_db_title2(inputs)
	if (locale === "fr") return fr_svc_backend_development_db_title2(inputs)
	if (locale === "pt") return pt_svc_backend_development_db_title2(inputs)
	if (locale === "zh") return zh_svc_backend_development_db_title2(inputs)
	if (locale === "tr") return tr_svc_backend_development_db_title2(inputs)
	if (locale === "ru") return ru_svc_backend_development_db_title2(inputs)
	if (locale === "pl") return pl_svc_backend_development_db_title2(inputs)
	return en_svc_backend_development_db_title2(inputs)
});
export { svc_backend_development_db_title2 as "svc_backend-development_DB_title" }